import {Injectable} from "@angular/core";
import { Data } from "@angular/router";
import {DataResponse, ListDataResponse} from "src/app/models/http.models";
import { Observable, Observer } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {
  AnagraficaDto,
  AnagraficaUtenteCorsoFormazioneDto,
  AnagraficaUtenteVarieCVDataDto
} from "../../models/anagrafica.models";
import {RegistrationRequest} from "../../models/registrazione.models";
import {AplDto, EsperienzaLavoroDto, MansioniDto} from "../../models/lavoro.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";
import {
  AnagraficaUtenteAttestatoDto, AnagraficaUtenteConoscenzeDto,
  AnagraficaUtenteIstruzioneDto,
  AnagraficaUtenteLingueDto, Attestato, Conoscenze, Lingua
} from "../../models/istruzione.models";
import {AnagraficaUtenteLavoroDesideratoDto, CorsoFormazioneDto, ProfiloPreferenze} from "../../models/preferenze.models";

@Injectable()

export class PreferencesService extends BaseApiService{

  public getAnagraficaUtenteLavoroDesiderato(profileId : number):Observable<DataResponse<AnagraficaUtenteLavoroDesideratoDto>>{
    return this.httpService.get(`PortalsPreferenze/GetAnagraficaUtenteLavoroDesideratoGetList?IdAnagraficaUtente=`+profileId);
  }

  public getRicercaCorsiFormazione(nome : string):Observable<DataResponse<CorsoFormazioneDto>>{
    return this.httpService.get(`PortalsPreferenze/RicercaCorsiFormazione?nome=`+nome);
  }

  public getOrarioPreferenze(orario : string):Observable<DataResponse<SharedEnumModelKeyValue>>{
    return this.httpService.get(`PortalsPreferenze/GetDisponibilitaOrario?orario=`+orario);
  }

  public getUpdatePreferenze(model: ProfiloPreferenze):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsPreferenze/UpdateProfiloPreferenze`, model);
  }
}
